export default {
  props: {
    eleConfig: { type: Object, default: () => ({ otherConfig: {} }) },
  },
  methods: {
    getNumber(input, defaultNum = 96) {
      let res = Number(input);
      if (isNaN(res)) return defaultNum;
      if (!res && res !== 0) return defaultNum;
      return res;
    },
    getImagePath(item) {
      const image = this.$dt(item, 'image') || item.image;
      return this.$Dolphin.path.publicPath + image?.filePath
    }
  },
}
